import {
  isDigitOnly,
  validateLengthBetween,
  validatePassword,
  validatePhoneNumberField,
} from '@v2/commons/utils/validators/validators.util'

export const getUserFormValidation = () => ({
  firstName: (value?: string) => (!value ? 'First name is required!' : null),
  lastName: (value?: string) => (!value ? 'Last name is required!' : null),
  username: (value?: string) => {
    if (!value) return 'Email is required!'
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return 'Invalid email format'
    }
    return null
  },
  password: (value?: string) => {
    const validateLength = validateLengthBetween(8, 20, 'Password', value)
    if (value && !validateLength) {
      return validatePassword(value)
    }
    return validateLength
  },
  phone: (value?: string) => {
    return validatePhoneNumberField(value ?? '')
  },
})
